/* @flow */

module.exports = {
  BASE_PATH: '/',
  API_ENDPOINT: '/data',
  MAPBOX_TOKEN: "pk.eyJ1IjoiY2FscG9seSIsImEiOiJjaXQ3cWczcHEwN29vMnVwMnowZjV6b3RhIn0.bWWIOGVGN7mQuza_RPpBVw",
  GOOGLE_ANALYTICS: {
    "CP": "UA-102181678-1",
    "AFD":"UA-31323973-3"
  },
  MAP: {
    defaultAttributions: [
      '<a href="https://www.calpoly.edu/privacy" target="_blank">Privacy Notice</a>',
      '&copy; Cal Poly',
      '<a href="https://www.mapbox.com/about/maps/" target="_blank">&copy; Mapbox</a>'
    ],
  },
  MAX_SEARCH_RESULTS: 25,
  TITLE: "Cal Poly Maps",
};
